import { CompanyEnrichType } from "@/enum/company-enrich-type.enum";

import { CreateCompanyEnrich } from "../schema/companyEnrich";

/**
 * Strip fields that are exclusive to a use-case other than the selected one so the
 * payload only carries data relevant to the chosen mode.
 */
export const normalizePayloadForMode = (
	values: CreateCompanyEnrich,
	mode: CompanyEnrichType
): CreateCompanyEnrich => {
	const normalized: CreateCompanyEnrich = { ...values, type: mode };

	if (mode !== CompanyEnrichType.LOOK_A_LIKE && normalized.companyFilterSimilar) {
		normalized.companyFilterSimilar = {
			...normalized.companyFilterSimilar,
			domains: [],
		};
	}

	if (mode !== CompanyEnrichType.NEW_IN_ROLE) {
		normalized.newInRole = null;
	}

	return normalized;
};

/**
 * Validate the workforce-growth sub-form: when a growth percentage bound is set, both
 * the period and department must be provided. Returns an error message or null.
 */
export const validateWorkforceGrowth = (values: Partial<CreateCompanyEnrich>): string | null => {
	const wg = values.companyFilterSearch?.workforceGrowth;
	const hasBounds = wg?.minPercent != null || wg?.maxPercent != null;

	if (!hasBounds) {
		return null;
	}

	const missingPeriod = wg?.period == null;
	const missingDepartment = wg?.department == null;

	if (missingPeriod && missingDepartment) {
		return "Period and department are required when growth percentage is set";
	}

	if (missingPeriod) {
		return "Period is required when growth percentage is set";
	}

	if (missingDepartment) {
		return "Department is required when growth percentage is set";
	}

	return null;
};
